import { httpClient } from './http';

export interface User {
  id: string;
  email: string;
  fullName?: string;
  username?: string;
  status?: string;
  role?: string;
  createdAt?: string;
  updatedAt?: string;
}

class UsersService {
  async getUserById(userId: string): Promise<User> {
    try {
      const response = await httpClient.get<User>(
        `/users/${userId}`,
        undefined,
        'authenticated'
      );
      return response;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw new Error('No se pudo obtener la información del usuario');
    }
  }
}

export const usersService = new UsersService();
